<template>
    <div class="container">

        <section class="top-cat">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 v-if="lang === 'ar'">برنامج بطاقة الولاء</h1>
                        <h1 v-else>WAFFIR PROGRAM</h1>
                        <p v-if="lang === 'ar'"><span>نقدم لكم أفضل الخصومات والعروض</span></p>
                        <p v-else>SERVING YOU THE BEST DISCOUNTS EVER</p>
                    </div>
                    <div class="col-md-12">
                        <h5 v-if="lang === 'ar'" align="center">الرجاء   <router-link to="/login">الضغط هنا</router-link> للدخول</h5>
                        <h5 v-else align="center">Please <router-link to="/login">Click Here</router-link> to Login.</h5>
                        <h5 v-if="lang === 'ar'" align="center">الرجاء  <router-link to="/register">الضغط هنا</router-link> لتسجيل بطاقتك</h5>
                        <h5 v-else align="center">Please <router-link to="/register">Click Here</router-link> to Register Your Card.</h5>
                    </div>
                </div>
            </div>
        </section>


    </div>
</template>
<script>
    import {mixin} from '@/mixins/mixins';

    export default {
        mixins: [mixin],
        // data () {
        //     return {
        //         //
        //     }
        // },
        computed: {
            auth () {
                return this.$store.getters['auth/isAuthenticated']
            },
            balance () {
                return this.$store.getters['account/getBalance']
            }
        },
        methods: {
            onLogout() {
                this.$store.dispatch('auth/logout')
            }
        }
    }
</script>
<style>
    /*@import url("https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css");*/
</style>


// WEBPACK FOOTER //
// src/components/website/waffir.vue